import { collectionEngine, collectionEngineV1 } from '../apis.js';
const req = collectionEngine('/files');
const reqV1 = collectionEngineV1('/files');
export const save = async (file, config) => {
    const upload = await reqV1('POST', `/${config?.parseInvoice ? '?parseInvoice=true' : ''}`, {
        body: file,
    });
    return {
        file: {
            contentType: file.contentType,
            fileName: file.name || upload.fileName,
            fileId: upload.id,
            meta: upload.meta,
        },
    };
};
export const get = (id, name) => req('GET', `/${id}${name != null ? name : ''}`);
//# sourceMappingURL=files.js.map